import React, { useState, useEffect, useRef } from 'react';
import { Button, Input, Table, Form, InputNumber, Spin, Select, Upload, Modal, Tabs, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, DownloadOutlined, PlusOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';//props传参检查库
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//審核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import trans from './translation';
import Message from '../../component/message/message';

const { Option } = Select;
const { TabPane } = Tabs;
const { confirm } = Modal;

const SysFunc = (props) => {

    const messageRef = useRef();
    const imageNum = 1;
    const [form] = Form.useForm();
    const type = Form.useWatch('type', form);
    const parentIdLevel2 = Form.useWatch('parentIdLevel2', form);
    const [tabIndex, setTabIndex] = useState("1");
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [imageFile, setImageFile] = useState([]);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [sysFuncList, setSysFuncList] = useState([]);
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [isMonitor, setIsMonitor] = useState(true);
    const [funcModel, setFuncModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [firstInput, setFirstInput] = useState(false);
    const [secondInput, setSecondInput] = useState(false);
    const [downloadModel, setDownloadModel] = useState("");
    
    const tableColumns = {
        funcCode: "func_code",
        funcName: "func_name",
        dispSeq: "disp_seq"
    }

    useEffect(() => {
        search(pageSize, 1, "N");
        searchAllFunc();
    }, []);

    useEffect(() => {
        if (isMonitor) {
            form.setFieldsValue({
                parentId: "",
                parentIdLevel2: type === 'SUBFUNC' ? parentIdLevel2 : "",
            });
        }
    }, [type, parentIdLevel2]);

    /**查詢所有模块 */
    const searchAllFunc = () => {
        Base.callBackApi("func/searchFunc").then((data) => {
            if ("SUCCESS" === data.msg) {
                setSysFuncList(data.object);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const searchChange = (k, e) => {
        messageShowHandler();
        setSearchModel(newSearchModel => {
            if ("parentId" === k) {
                newSearchModel.parentIdLevel2 = null;
                newSearchModel.funcId = null;
            }
            if ("parentIdLevel2" === k) {
                newSearchModel.funcId = null;
            }
            return { ...newSearchModel, ...{ [k]: e } };
        })
        if (k === 'parentId') {
            if (sysFuncList.filter(item => item.parentId === e).length > 0) {
                setFirstInput(true);
            } else {
                setFirstInput(false);
            }
        }
        if (k === 'parentIdLevel2') {
            if (Base.isEmpty(e)) {
                setSecondInput(false);
                return
            }
            if (sysFuncList.filter(item => item.parentId === e).length > 0) {
                setSecondInput(true);
            }
        }
    }

    //查询
    const search = (pageSizeNew, current, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        setDownloadModel(model)
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("func/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    //重置
    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    //添加
    const add = () => {
        messageShowHandler();//清空提示信息
        initForm({ activeInd: "Y" });
        setFlag("add");
        setTabIndex("2");
        setImageFile([]);
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            parentId: model.parentId ?? '',
            funcCode: model.funcCode ?? '',
            funcName: model.funcName ?? '',
            type: model.type ?? '',
            parentIdLevel2: model.parentIdLevel2 ?? '',
            dispSeq: model.dispSeq ?? '',
            img: model.img ?? '',
            funcUrl: model.funcUrl ?? '',
            funcNameTc: model.funcNameTc ?? '',
            funcNameEn: model.funcNameEn ?? '',
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    //删除
    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let model = funcModel;
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("func/delete", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setSearchModel({});
                searchAllFunc();
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
                props.searchMenu(Config.userInfo.role);//刷新menu
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    // 审核弹窗
    const auditCancel = () => {
        setIsAudit(false);
    }

    const downloadExcel = () => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.download[Config.backLang])
        fetch(Config.apiDownloadServer + "func/exportReport", {
            method: 'POST',
            body: JSON.stringify(downloadModel),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, trans.downloadFunc[Config.backLang]);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = trans.downloadFunc[Config.backLang];
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }

    const onSave = (model) => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        if (imageFile && imageFile.length > 0) {
            model.imageUploadModel = {
                status: imageFile[0].imgStatus,
                url: imageFile[0].originUrl,
            };
        }
        let url = "";
        if (flag === "add") {
            url = "func/insert";
        } else if (flag === "edit") {
            url = "func/update";
            model.funcId = funcModel.funcId;
            model.lastUpdatedDate = funcModel.lastUpdatedDate;
        }
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, model).then((data) => {
            if ("SUCCESS" == data.msg) {
                searchAllFunc();
                setIsMonitor(false);
                searchById(data.object)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            props.searchMenu(Config.userInfo.role);
            setIsLoad(false)
        });
    }

    //取消 
    const cancel = () => {
        setIsMonitor(true);
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    /** 生成提示信息 */
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    /** 清空提示信息 */
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div>{trans.settingsImg[Config.backLang]}</div>
        </div>
    );

    const update = (model, e) => {
        e.stopPropagation();
        setIsMonitor(false);
        searchById(model.funcId)
        setTabIndex("2");
    }

    const searchById = (rsServiceItemId, isDelete) => {
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("func/searchById", rsServiceItemId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                if (isDelete) {
                    setDeleteTipText(trans.funcCode[Config.backLang] + ":" + model.funcCode)
                    setIsDeleteFrame(true);
                    return
                }
                let file = [];
                if (model.image) {
                    file.push({
                        url: Config.funcImg + model.image + '?' + Config.sasToken,
                        originUrl: model.image + '?' + Config.sasToken,
                        imgStatus: "OLD",
                    })
                }
                setImageFile(file);
                setFlag("edit");
                initForm(model)
                setFuncModel(model)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        setFuncModel(model)
        searchById(model.funcId, true)
    }

    const handleRemove = (file) => {
        confirm({
            content: trans.deleteImg[Config.backLang],
            okText: trans.ok[Config.backLang],
            okType: 'danger',
            cancelText: trans.cancel[Config.backLang],
            onOk() {
                let index = imageFile.findIndex(item => item.uid == file.uid);
                let fileList = JSON.parse(JSON.stringify(imageFile));
                fileList.splice(index, 1);
                setImageFile(fileList);
            },
            onCancel() {
            },
        });
        return false;
    }

    /**图片改变事件 */
    const handleChange = (file) => {
        let fileList = file.fileList;
        file = file.file;
        if (file.status === "removed") {
            let index = imageFile.findIndex(item => item.uid == file.uid);
            let fileList = JSON.parse(JSON.stringify(imageFile));
            fileList.splice(index, 1)
        } else {
            const reader = new FileReader();
            reader.readAsDataURL(file.originFileObj);
            reader.onload = (e) => {
                fileList[fileList.length - 1].originUrl = e.target.result;
                fileList[fileList.length - 1].imgStatus = "NEW";
            }
        }
        setImageFile(fileList);
    }

    /**关闭图片弹窗 */
    const handleCancel = () => {
        setPreviewVisible(false);
    }

    const checkImg = (value) => {
        if (!!imageFile && imageFile.length > 0 && !!value) {
            let list = value.fileList;
            if (list.find(item => item.status === "uploading")) {
                return Promise.reject(trans.awaitImg[Config.backLang]);
            }
            if (list.find(item => item.status === "error")) {
                return Promise.reject(trans.loseImg[Config.backLang]);
            }
        }
        return Promise.resolve();
    }

    /**查看图片 */
    const handlePreview = (file) => {
        setPreviewImage(file.url || file.thumbUrl);
        setPreviewVisible(true);
    }

    /*eslint-disable*/
    const columns = [
        {
            title: trans.funcCode[Config.backLang],
            dataIndex: 'funcCode',
            className: 'tableWidth23',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'funcCode') },
        },
        {
            title: trans.funcName[Config.backLang],
            dataIndex: Config.backLang === "SC" ? "funcName" : (Config.backLang === "TC" ? "funcNameTc" : "funcNameEn" ),
            className: 'tableWidth23',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'funcName') },
        }, {
            title: trans.type[Config.backLang],
            dataIndex: 'type',
            className: 'tableWidth18',
            render: (text) => ContextHandler.getMapValueTransalation('funcTypeMap', text)
        }, {
            title: trans.dispSeq[Config.backLang],
            dataIndex: 'dispSeq',
            className: 'tableWidth13 tableRightAlignment',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'dispSeq') },
        }, {
            title: trans.funcUrl[Config.backLang],
            dataIndex: 'funcUrl',
            className: 'tableWidth23',
        }, {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            fixed: 'right',
            width: 206,
            className: ' sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];
    /*eslint-enable*/

    return (
        <div id="container" className="template">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.sysManage[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysFunc'>
                                <div className='sysSearchRows'>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.funcName[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Select className="sysSelect" placeholder={trans.funcName[Config.backLang]}
                                                    value={searchModel.parentId || ''}
                                                    onChange={(e) => searchChange('parentId', e)}
                                                >
                                                    <Option value=""></Option>
                                                    {sysFuncList.filter(item => item.type === 'MENU').map((item) => <Option key={item.funcId} value={item.funcId}>{Config.backLang === "SC" ? item.funcName : (Config.backLang === "TC" ? item.funcNameTc : item.funcNameEn)}</Option>)}
                                                </Select>
                                            </div>
                                        </div>
                                        {firstInput &&
                                            <div className='sysColFunc'>
                                                <div className="sysSerchFuncInput">
                                                    <Select className="sysSelect" placeholder={trans.funcName[Config.backLang]}
                                                        disabled={!searchModel.parentId}
                                                        value={searchModel.parentIdLevel2 || ''}
                                                        onChange={(e) => searchChange('parentIdLevel2', e)}
                                                    >
                                                        <Option value=""></Option>
                                                        {sysFuncList.filter(item => item.parentId === searchModel.parentId).map((item) => <Option key={item.funcId} value={item.funcId}>{Config.backLang === "SC" ? item.funcName : (Config.backLang === "TC" ? item.funcNameTc : item.funcNameEn)}</Option>)}
                                                    </Select>
                                                </div>
                                            </div>
                                        }
                                        {secondInput &&
                                            <div className='sysColFunc'>
                                                {/* <div className="sysTitles"></div> */}
                                                {/* <div className="sysTitle">三级模块名称</div> */}
                                                <div className="sysSerchFuncInput">
                                                    <Select className="sysSelect" placeholder={trans.funcName[Config.backLang]}
                                                        disabled={!searchModel.parentIdLevel2}
                                                        value={searchModel.funcId || ''}
                                                        onChange={(e) => searchChange('funcId', e)}
                                                    >
                                                        <Option value=""></Option>
                                                        {sysFuncList.filter(item => item.parentId === searchModel.parentIdLevel2).map((item) => <Option key={item.funcId} value={item.funcId}>{Config.backLang === "SC" ? item.funcName : (Config.backLang === "TC" ? item.funcNameTc : item.funcNameEn)}</Option>)}
                                                    </Select>
                                                </div>
                                            </div>
                                        }
                                        <div className='sysSearchButton'>
                                            <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                            <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button className="sysBtn btnBlue" type="primary" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                                {tables.length == 0 ? null :
                                    <>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={downloadExcel} hidden={Config.funcInfo.canDownload === "N"} icon={<DownloadOutlined />}>{trans.downloadExcel[Config.backLang]}</Button>
                                    </>
                                }
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1550 }}
                                    rowKey="funcId"
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,         //当前页
                                        pageSize: pageSize,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.func[Config.backLang]} forceRender={true}>
                            <Form
                                form={form} onFinish={onSave}
                            >
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.funcCode[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="funcCode"
                                                rules={[
                                                    { required: true, message: trans.funcCodeIsNoNull[Config.backLang] },
                                                ]}
                                                getValueFromEvent={(e) => Base.codeChange(e, 20)}
                                            >
                                                <Input type="text"
                                                    placeholder={trans.funcCode[Config.backLang]} maxLength={30}
                                                    disabled={flag === 'edit'}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.funcNameEN[Config.backLang]} </div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="funcNameEn"
                                                rules={[
                                                    { required: true, message: trans.funcNameIsNoNullEN[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text"
                                                    placeholder={trans.funcNameEN[Config.backLang]}
                                                    maxLength={50}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.funcNameSC[Config.backLang]} </div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="funcName"
                                                rules={[
                                                    { required: true, message: trans.funcNameIsNoNullSC[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text"
                                                    placeholder={trans.funcNameSC[Config.backLang]}
                                                    maxLength={50}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.funcNameTC[Config.backLang]} </div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="funcNameTc"
                                                rules={[
                                                    { required: true, message: trans.funcNameIsNoNullTC[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text"
                                                    placeholder={trans.funcNameTC[Config.backLang]}
                                                    maxLength={50}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.type[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="type"
                                                rules={[
                                                    { required: true, message: trans.typeIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select placeholder={trans.type[Config.backLang]} disabled={flag === 'edit'} className='sysSelect'>
                                                    <Option value=''></Option>
                                                    {context.funcTypeMap.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    {type === "FUNC" ?
                                        <>
                                            <div className='sysCol'>
                                                <div className="sysParam mustFill">{trans.oneFunc[Config.backLang]}</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="parentId"
                                                        rules={[
                                                            { required: true, message: trans.oneFuncIsNoNull[Config.backLang] },
                                                        ]}
                                                    >
                                                        <Select placeholder={trans.oneFunc[Config.backLang]} className='sysSelect'>
                                                            <Option value=''></Option>
                                                            {sysFuncList.filter(item => item.type === 'MENU').map((item) => <Option key={item.funcId} value={item.funcId}>{Config.backLang === "SC" ? item.funcName : (Config.backLang === "TC" ? item.funcNameTc : item.funcNameEn)}</Option>)}
                                                        </Select>
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </>
                                        : null}
                                </div>
                                {type === "SUBFUNC" ?
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.oneFunc[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="parentIdLevel2"
                                                    rules={[
                                                        { required: true, message: trans.oneFuncIsNoNull[Config.backLang] },
                                                    ]}
                                                >
                                                    <Select placeholder={trans.oneFunc[Config.backLang]} className='sysSelect'>
                                                        <Option value=''></Option>
                                                        {sysFuncList.filter(item => item.type === 'MENU').map((item) => <Option key={item.funcId} value={item.funcId}>{Config.backLang === "SC" ? item.funcName : (Config.backLang === "TC" ? item.funcNameTc : item.funcNameEn)}</Option>)}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.twoFunc[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="parentId"
                                                    rules={[
                                                        { required: true, message: trans.twoFuncIsNoNull[Config.backLang] },
                                                    ]}
                                                >
                                                    <Select placeholder={trans.twoFunc[Config.backLang]} disabled={!parentIdLevel2} className='sysSelect'>
                                                        <Option value=''></Option>
                                                        {sysFuncList.filter(item => item.parentId === parentIdLevel2).map((item) => <Option key={item.funcId} value={item.funcId}>{Config.backLang === "SC" ? item.funcName : (Config.backLang === "TC" ? item.funcNameTc : item.funcNameEn)}</Option>)}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    : null}
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.dispSeq[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="dispSeq"
                                                rules={[
                                                    { required: true, validator: (rule, value) => Base.checkNbrOrNull(value, null, 999999999) },
                                                ]}
                                            >
                                                <InputNumber className='sysInputNumber'
                                                    placeholder={trans.dispSeq[Config.backLang]}
                                                    precision={0} maxLength={9}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.funcUrl[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item name="funcUrl">
                                                <Input type="text" placeholder={trans.funcUrl[Config.backLang]} maxLength={100} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.img[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Modal title={trans.maxImg[Config.backLang]} visible={previewVisible} footer={null} onCancel={handleCancel}>
                                                <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                            </Modal>
                                            <Form.Item
                                                name="img"
                                                rules={[
                                                    { validator: (rule, value) => checkImg(value) }
                                                ]}
                                            >
                                                <Upload
                                                    action={Config.uploadTestServer}
                                                    key={"1"}
                                                    accept=".png, .jpg, .jpeg"
                                                    listType="picture-card"
                                                    fileList={imageFile}
                                                    onPreview={handlePreview}
                                                    onRemove={handleRemove}
                                                    onChange={(file) => handleChange(file)}>
                                                    {imageFile.length >= imageNum ? null : uploadButton}
                                                </Upload>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} htmlType="submit" icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        </div>
    )
}

SysFunc.propTypes = {
    searchMenu: PropTypes.func.isRequired,
}

export default SysFunc;